<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>

            <section class="client-section">
                <v-img src="/images/business/domestic/rights/middle.jpg" alt="" class="d-md-none" />
                <div class="d-none d-md-block">
                    <v-card img="/images/business/domestic/rights/business.jpg" color="#FEFCFB" tile flat>
                        <v-responsive :aspect-ratio="1920 / 432">
                            <v-container class="h-100 py-50">
                                <v-row align="center" class="h-100">
                                    <v-col cols="12" lg="5">
                                        <v-row>
                                            <v-col cols="12">
                                                <div class="tit tit--sm line-height-15 font-weight-regular">
                                                    모든 아이들이 <strong class="primary--text">보호받고 존중받으며</strong> <br />
                                                    <strong class="primary--text">스스로의 권리를 누릴 수 있도록</strong> 지원합니다.
                                                </div>
                                            </v-col>
                                            <v-col cols="12">
                                                <p class="page-text page-text--lg grey-1--text">
                                                    위드캔복지재단과 함께하면, 아이들이 차별과 어려움을 넘어 <br />
                                                    존중과 보호 속에서 꿈과 희망을 키울 수 있습니다.
                                                </p>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-responsive>
                    </v-card>
                </div>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <program-list :items="programs" />
                </v-container>
            </section>
        </div>
        <section>
            <bottom-banner :item="banner" />
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
    },
    data() {
        return {
            visual: {
                sh: "국내복지사업",
                tabActive: "아동권리옹호사업",
                text: "우리는 단순한 지원을 넘어, 지속 가능한 변화를 만들어 갑니다.",
                bg: "/images/business/domestic/visual.jpg",
                mobile: "/images/business/domestic/mobile-visual.jpg",
            },
            intro: {
                image: "/images/business/domestic/rights/intro.jpg",
                texts: "위드캔복지재단은 아동권리옹호사업을 통해 모든 아동이 안전하게 보호받고, 자신의 권리를 온전히 누릴 수 있도록 지원합니다. <br class='d-none d-xl-block' />아동의 권리를 지키기 위한 캠페인과 교육, 정책 개선 활동을 펼치며, 아동이 건강하고 행복한 삶을 살 수 있는 환경을 조성합니다. <br class='d-none d-xl-block' />또한, 아동 학대 예방과 권리 증진을 위한 다양한 프로그램을 운영하여, 모든 아동이 차별 없이 존중받는 세상을 만들어가고 있습니다.",
            },
            programs: [
                {
                    image: "/images/business/domestic/rights/program-1.jpg",
                    title: "심리·정서 지원 프로그램",
                    texts: [
                        "아동의 마음 건강 증진을 위해 전문 심리치료, <br class='d-none d-sm-block' />마음건강증진사업, 가족통합 서비스를 제공합니다.",
                        "아동·청소년이 건강하게 성장할 수 있도록 함께합니다.",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/rights/program-2.jpg",
                    title: "아동권리·안전망 프로그램",
                    texts: [
                        "위험에 처한 아동을 조기 발견하고 지원하여 <br class='d-none d-sm-block' />아동이 안전한 환경에서 성장할 수 있도록 지원합니다.",
                        "UN아동권리협얍을 준수 할 수 있도록 <br class='d-none d-sm-block' />다양한 인식 개선 활동을 펼칩니다."
                        //
                    ],
                },
            ],
            banner: {
                image: "/images/business/domestic/rights/bottom-banner.jpg",
                mobile: "/images/business/domestic/rights/bottom.jpg",
            },
        };
    },
};
</script>